import React, { forwardRef } from 'react';

const ErrorMessage = forwardRef(({ message, className = '', ...props }, ref) => {
  if (!message) return null;

  return (
    <p
      {...props}
      ref={ref}
      className={`absolute w-full text-red-500 text-sm xl:mt-1 ${className}`}
      role="alert"
    >
      {message}
    </p>
  );
});

export default ErrorMessage;
